import { useQuery } from '@tanstack/react-query';
import { tasksApi } from '@/api/tasks';
import { queryKeys } from '@/query/queryKeys';

type Params = {
  calendarId?: string;
  status?: string;
  dueAfter?: string;
  dueBefore?: string;
};

const useTasksQuery = (params: Params = {}, options: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: queryKeys.tasks(params),
    queryFn: () => tasksApi.list(params),
    enabled: options.enabled ?? true,
  });

export { useTasksQuery };
